import React, { useContext } from 'react';
import { OwnerContext } from '../../context/OwnerContext';
import { ChatProvider } from '../../context/ChatContext';
import OwnerLayout from '../owner/OwnerLayout';
import ChatPage from './ChatPage';

const OwnerChatPage = () => {
    const { owner } = useContext(OwnerContext);

    if (!owner) return null;

    return (
        <OwnerLayout noPadding fullWidth>
            <ChatProvider userId={owner.id}>
                <ChatPage
                    userId={owner.id}
                    userRole="ROLE_OWNER"
                    schoolId={owner.schoolId}
                />
            </ChatProvider>
        </OwnerLayout>
    );
};

export default OwnerChatPage;
